var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "669.08 102.55 619.71 103.15 620.49 167.53 669.87 168.17 669.08 102.55",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "665.56 104.89 622.36 105.41 623.07 163.79 666.28 164.73 665.56 104.89",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "658.42 115.58 629.75 114.84 630.24 155.65 658.9 155.3 658.42 115.58",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "630.24 155.65 658.65 134.34 629.75 114.84 630.24 155.65",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.07 144.54 71.05 145.4 72.17 238.02 143.22 238.95 142.07 144.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.01 147.9 74.86 148.65 75.88 232.66 138.05 234 137.01 147.9",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.74 163.29 85.48 162.22 86.19 220.93 127.43 220.43 126.74 163.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.19 220.93 127.07 190.27 85.48 162.22 86.19 220.93",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.47,
    y: 119.32,
    width: 26.6,
    height: 56.95,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.18,
    y: 180.24,
    width: 32.69,
    height: 55.02,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.85 118.33 267.89 118.33 267.89 67.82 269 67.82 269 118.33 297.72 118.33 297.72 66.7 236.85 66.7 236.85 118.33",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.47,
    y: 180.24,
    width: 26.6,
    height: 55.02,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.99,
    y: 180.24,
    width: 28.73,
    height: 55.02,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.18,
    y: 119.32,
    width: 32.69,
    height: 56.95,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.99,
    y: 119.32,
    width: 28.73,
    height: 56.95,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.47,
    y: 236.25,
    width: 26.6,
    height: 49.58,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.08 118.33 199.08 67.82 200.18 67.82 200.18 118.33 232.87 118.33 232.87 66.7 172.47 66.7 172.47 118.33 199.08 118.33",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.18,
    y: 236.25,
    width: 32.69,
    height: 49.58,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.99,
    y: 236.25,
    width: 28.73,
    height: 49.58,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.85,
    y: 119.32,
    width: 31.04,
    height: 56.95,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.85,
    y: 236.25,
    width: 31.04,
    height: 49.58,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.85,
    y: 180.24,
    width: 31.04,
    height: 55.02,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.65,
    y: 119.32,
    width: 26.6,
    height: 56.95,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.36,
    y: 180.24,
    width: 32.69,
    height: 55.02,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "523.03 118.33 554.07 118.33 554.07 67.82 555.17 67.82 555.17 118.33 583.9 118.33 583.9 66.7 523.03 66.7 523.03 118.33",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.65,
    y: 180.24,
    width: 26.6,
    height: 55.02,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 555.17,
    y: 180.24,
    width: 28.73,
    height: 55.02,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.36,
    y: 119.32,
    width: 32.69,
    height: 56.95,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 555.17,
    y: 119.32,
    width: 28.73,
    height: 56.95,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.65,
    y: 236.25,
    width: 26.6,
    height: 49.58,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.26 118.33 485.26 67.82 486.36 67.82 486.36 118.33 519.05 118.33 519.05 66.7 458.65 66.7 458.65 118.33 485.26 118.33",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.36,
    y: 236.25,
    width: 32.69,
    height: 49.58,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 555.17,
    y: 236.25,
    width: 28.73,
    height: 49.58,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.03,
    y: 119.32,
    width: 31.04,
    height: 56.95,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.03,
    y: 236.25,
    width: 31.04,
    height: 49.58,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.03,
    y: 180.24,
    width: 31.04,
    height: 55.02,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.35,
    y: 86.72,
    width: 59.29,
    height: 74.85,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.26,
    y: 159.9,
    width: 8.22,
    height: 2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 112.49 365.98 114.09 361.9 124.35 368.74 133.01 379.67 131.41 383.74 121.15 376.9 112.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382 119.12 371.08 120.72 367 130.98 373.85 139.64 384.77 138.04 388.85 127.78 382 119.12",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.42,
    y: 85.71,
    width: 8.22,
    height: 1.71,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.36 342.18 65.36 439.86 211.78 439.86 211.78 341.39 65.36 342.18",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.9,
    y: 348.24,
    width: 135.35,
    height: 24.71,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.9,
    y: 378.75,
    width: 135.35,
    height: 24.71,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.9,
    y: 409.25,
    width: 135.35,
    height: 24.71,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.9,
    y: 348.24,
    width: 41.96,
    height: 24.71,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.9,
    y: 378.75,
    width: 41.96,
    height: 24.71,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.71,
    y: 409.08,
    width: 41.96,
    height: 24.71,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.04 372.95 129.26 352.42 143.77 372.95 116.04 372.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.26 352.42 129.9 372.95 116.04 372.95 129.26 352.42",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.41 372.95 154.04 365.16 160.73 372.95 148.41 372.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.04 365.16 154.57 372.95 148.41 372.95 154.04 365.16",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.91,398.54h0a4.51,4.51,0,0,1,4.39-4.34l35.78-.82v9.83H100.41A4.51,4.51,0,0,1,95.91,398.54Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.54,396.13a5.28,5.28,0,0,0,0,5.39h36.54v-6.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.88,389.8h0a3.5,3.5,0,0,1,3.42-3.38l27.89-.67v7.67l-27.8,0A3.51,3.51,0,0,1,104.88,389.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71,388a4.1,4.1,0,0,0,0,4.2l28.48,0v-5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.25 380.85 136.16 403.39 140.87 403.46 140.87 380.85 136.25 380.85",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.23 383.98 146.1 403.4 153.39 403.46 153.39 383.98 146.23 383.98",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.97 383.98 140.93 403.4 143.28 403.46 143.28 383.98 140.97 383.98",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.44 383.98 153.39 403.4 155.75 403.46 155.75 383.98 153.44 383.98",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.93 380.85 142.87 403.39 146.09 403.46 146.09 380.85 142.93 380.85",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.9 380.85 155.85 403.39 159.06 403.46 159.06 380.85 155.9 380.85",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7,403.14h-11l0,0-7.95-7.89.09-.08,7.89-7.91h.05l8.06-.61,0,0,8.89,7Zm-10.86-.25h10.72l5.88-9.19-8.68-6.82-7.92.59-7.74,7.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.03 403.09 172.91 394.46 172.94 394.39 176.75 387.14 179.1 389.44 182.82 389.44 184.81 386.52 189.33 393.66 189.3 393.73 184.61 403.08 184.38 402.96 189.05 393.68 184.8 386.98 182.95 389.69 178.99 389.69 178.96 389.65 176.82 387.56 173.2 394.44 179.24 402.95 179.03 403.09",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.94 395.35 168.91 395.1 177.51 393.91 186.55 393.55 193.61 393.54 193.61 393.79 186.55 393.8 177.53 394.16 168.94 395.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.16 403.06 177.4 394.03 177.41 393.99 178.93 389.52 179.16 389.61 177.66 394.03 180.4 402.98 180.16 403.06",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.59 403.06 182.35 402.99 185.06 393.69 182.78 389.63 183 389.5 185.32 393.65 185.31 393.7 182.59 403.06",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.22,288.23c-6.47,1-9.36,9-8.79,15.5s3.24,12.89,2.53,19.4c-.91,8.26-7.16,15.25-7.88,23.53-.86,9.76,6,18.42,8.1,28,1,4.66.87,9.59,2.6,14a17.55,17.55,0,0,0,33.89-6.05c.15-7.5-4.48-14.56-3.92-22,.42-5.53,3.66-10.76,3-16.26-.82-6.55-6.89-11.19-9-17.43s-.08-13.12-.82-19.68c-1.33-11.76-7.85-20-19.64-19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.21,345.17c-1.1,10.9,3.72,23.72,9.33,33.13a52,52,0,0,0,24.4,21.18c1.14.48,2.55.88,3.51.1a3.47,3.47,0,0,0,.89-2.8c.08-11.46-3.93-22.73-10.47-32.15-6.23-9-12.11-14.31-27.66-19.46",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.69,422.27a3.16,3.16,0,0,1-.31-.61c-.21-.47-.47-1.06-.78-1.79-.66-1.55-1.63-3.79-2.88-6.54A226.36,226.36,0,0,0,623,372.67c-1.79-2.44-3.26-4.39-4.29-5.72l-1.18-1.56a2.39,2.39,0,0,1-.37-.57,4.47,4.47,0,0,1,.47.49l1.26,1.49c1.1,1.29,2.62,3.2,4.46,5.61a198.49,198.49,0,0,1,23.81,40.74c1.2,2.78,2.12,5.05,2.7,6.64.27.74.5,1.34.67,1.82A2.8,2.8,0,0,1,650.69,422.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.67,318.38a6.76,6.76,0,0,1,.12,1c.05.74.13,1.74.22,3,.17,2.67.41,6.43.71,11,.59,9.33,1.41,22.21,2.41,36.43s2,27.09,2.71,36.41c.36,4.62.64,8.37.85,11,.08,1.26.15,2.27.2,3a7,7,0,0,1,0,1.05,7.47,7.47,0,0,1-.15-1c-.08-.74-.19-1.74-.32-3-.25-2.67-.61-6.41-1-11-.84-9.31-1.89-22.18-2.89-36.41s-1.76-27.11-2.24-36.44c-.21-4.62-.39-8.39-.51-11.06,0-1.26-.08-2.26-.11-3A7.62,7.62,0,0,1,643.67,318.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.65,406.72h27.29v20a13.1,13.1,0,0,1-13.1,13.1h0a13.09,13.09,0,0,1-13.08-12.4Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M704.17,439.86c0,.15-147.39.26-329.15.26S45.83,440,45.83,439.86s147.36-.26,329.19-.26S704.17,439.72,704.17,439.86Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.47,213.31h0a8,8,0,0,0,8.49-7.74c.11-4.34.21-8.72.21-8.72s6.56-.7,7-7.2,0-21.52,0-21.52h0a22.69,22.69,0,0,0-22.89,1.73l-1,.7.77,35A8,8,0,0,0,274.47,213.31Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.18,179.61a.95.95,0,1,1,1.34,0A.95.95,0,0,1,287.18,179.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.71,178.48c-.11.11-.73-.42-1.62-.46s-1.57.38-1.67.26.07-.25.36-.46a2.23,2.23,0,0,1,1.34-.35,2.17,2.17,0,0,1,1.28.52C289.67,178.22,289.76,178.43,289.71,178.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.67,178.48A.95.95,0,1,1,277.6,180a.95.95,0,0,1,1.07-1.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.93,178.8c-.11.11-.72-.42-1.62-.46s-1.57.38-1.66.26.06-.25.36-.46a2.2,2.2,0,0,1,2.62.17C279.9,178.54,280,178.75,279.93,178.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.2,185.72a4.34,4.34,0,0,1,1.46-.23c.24,0,.42-.06.45-.19a1.25,1.25,0,0,0-.14-.68c-.2-.6-.4-1.21-.62-1.85a25.74,25.74,0,0,1-1.3-4.87,24.48,24.48,0,0,1,1.79,4.71l.58,1.87a1.52,1.52,0,0,1,.08,1,.64.64,0,0,1-.42.36,1.52,1.52,0,0,1-.41,0A4.14,4.14,0,0,1,283.2,185.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.23,186.57l4.34,1.5a2.49,2.49,0,0,1-3,.84C279.68,188.1,280.23,186.57,280.23,186.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.18,196.75a15.19,15.19,0,0,1-8.37-2.83s1.78,4.79,8.3,4.52Z",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.74,166.42a29.7,29.7,0,0,0-16.7-.87s-5.53,2-5.78,5a51.79,51.79,0,0,0,.16,7.34h0l.47,5,2,0,.2-6.78s3.8-2.69,3.83-6.81c1.86-.27,11-1.46,17.28.59l0-1.45A2.21,2.21,0,0,0,288.74,166.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.16,178.42a1,1,0,0,0-1-1c-1.21,0-3.19.48-3.34,3.84-.21,4.79,4.38,3.54,4.4,3.4S267.2,180.28,267.16,178.42Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.19,182.82s-.09.06-.23.12a.84.84,0,0,1-.62,0,2.07,2.07,0,0,1-.88-1.89,2.82,2.82,0,0,1,.29-1.19.94.94,0,0,1,.65-.61.41.41,0,0,1,.48.25c.06.14,0,.23.05.24s.11-.08.08-.28a.54.54,0,0,0-.18-.3.62.62,0,0,0-.45-.15,1.2,1.2,0,0,0-.91.71,2.81,2.81,0,0,0-.34,1.32,2.17,2.17,0,0,0,1.12,2.12.86.86,0,0,0,.77-.09C266.18,182.94,266.21,182.83,266.19,182.82Z",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,183.76c-1.3-.45-4,6.55-4.26,4.71s4.25-8.19,2.87-8.61c-1.8-.55-4.45,6.84-4.72,7.44s-1.16.24-.89-.29c.39-.78,4.33-9,2.57-9.53-1-.31-1.37,1.5-1.37,1.5s-3.12,7.94-3.94,7.65.84-5,1.52-6.57.21-2.48-.72-2.21c-.63.18-2.81,4.89-3.45,6.44s-2.29,5.83-3.19,3.05-2.64-4.57-3.45-4.73a.91.91,0,0,0-.71,1.57,10.42,10.42,0,0,1,1.42,2.58,7,7,0,0,1,.55,2.3,24.32,24.32,0,0,1-.08,4.77L328.1,222.72,302.34,213l-3.54,14.72s33.84,14.91,35.95,13.76c4.78-2.6,19.8-44.64,19.8-44.64h0a99.55,99.55,0,0,0,6.2-8.9C362.86,184.13,362.53,183.93,362,183.76Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.29,218.06c-7.16-3.57-12.23-5.68-16.15-8.13-12.17-7.61-15.33-5.85-18.18-6.17-2.38.76-5.89,2.2-7.23,2.46s-6.25-1.33-9.42-2.27h0c-7.35.41-11.81,3.59-18.54,8.67L235.1,223.46,251.28,240l5-3.8c.3,7.49.57,7.56.95,15.24l.32,29.58,45.73,2-2.88-29.55L299,230.22l13.11,6.34,6.21-18.5",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.68,204.83l-.06-4.75s8.17.76,9.9,6.41Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,204.48l-.73-4.6a8,8,0,0,0-6.78,6.61Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,221.29a7.86,7.86,0,0,1,1.57-.13c1,0,2.57-.12,4.43-.17h.22v.22c0,1.81.07,3.88.12,6.11v.13l-.11.08-.44.31-2.33,1.64-.14.1-.14-.09-3.22-2-.11-.07v-.12c0-1.85,0-3.37.06-4.41a9.83,9.83,0,0,1,.09-1.57A16.58,16.58,0,0,1,285,223c0,1.05.12,2.52.16,4.27l-.1-.19,3.25,2H288l2.33-1.65.43-.31-.11.21c0-2.22,0-4.3,0-6.1l.22.21c-1.76,0-3.23,0-4.28-.06A16.52,16.52,0,0,1,284.84,221.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.71,222.71a9.1,9.1,0,0,1-3,.25,8.85,8.85,0,0,1-3-.26,8.6,8.6,0,0,1,3-.26A8.49,8.49,0,0,1,290.71,222.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.69,215.36a18.6,18.6,0,0,1-.32-4.43,18.59,18.59,0,0,1,.21-4.44,19.52,19.52,0,0,1,.31,4.43A19.66,19.66,0,0,1,276.69,215.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.32,207.67c0-.06.21-.18.47,0a.65.65,0,0,1,.21.56.68.68,0,0,1-1.24.22.58.58,0,0,1,0-.59c.17-.3.43-.27.43-.21s-.08.17-.09.33.07.29.26.26.21-.15.15-.33S278.32,207.74,278.32,207.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.94,211.21c0-.07.26-.07.42.23a.64.64,0,0,1,0,.58.72.72,0,0,1-1.28-.05.66.66,0,0,1,.05-.58c.19-.29.44-.26.44-.2s-.08.17-.1.34,0,.32.25.34.28-.13.28-.32S278.92,211.28,278.94,211.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.58,204s-.18,0-.43.05a1.16,1.16,0,0,0-.72.83,15.38,15.38,0,0,0-.31,1.85c-.12.74-.25,1.51-.38,2.31l-.07.42-.33-.23-.6-.42a31.17,31.17,0,0,1-3.66-3.08,6.56,6.56,0,0,1-1.28-1.51c.11-.11,2.23,2,5.24,4.16l.59.42-.4.18.43-2.34a11.55,11.55,0,0,1,.45-1.88,1.31,1.31,0,0,1,1-.89C274.45,203.8,274.6,204,274.58,204Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.3,203.93a13.24,13.24,0,0,1-3.59,5.29l-.13.11-.37.36-.06-.51a17.38,17.38,0,0,0-2.1-5.7,4.38,4.38,0,0,1,1.15,1.43,11,11,0,0,1,1.46,4.2l-.43-.15.11-.12A38,38,0,0,0,284.3,203.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.97 230.22 303.26 230.44 312.92 233.75 312.08 236.56 298.97 230.22",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.44,245.91a171.4,171.4,0,0,1-27.47.47,25.25,25.25,0,0,1-9.17-1.84,14.89,14.89,0,0,1-7.56-8.36l.82,12.74Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.87,216.9c-.12.08-.86-.77-1.66-1.91a6.08,6.08,0,0,1-1.23-2.2c.12-.08.86.77,1.66,1.9A6.16,6.16,0,0,1,257.87,216.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.47,227.86a9.66,9.66,0,0,1,1-3,10.09,10.09,0,0,1,1.52-2.79,10.09,10.09,0,0,1-1,3A9.94,9.94,0,0,1,248.47,227.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.48,231.82a8.45,8.45,0,0,1-2.11-2,8.66,8.66,0,0,1-1.72-2.37,16.27,16.27,0,0,1,3.83,4.39Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.91,220.42c.09.11-.66.9-1.68,1.77s-1.93,1.48-2,1.37.67-.9,1.69-1.77S266.82,220.31,266.91,220.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269,215.36c-.1.1-.87-.54-1.58-1.53s-1.08-1.92-1-2,.69.72,1.38,1.67S269.11,215.26,269,215.36Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.77,237.84a12.5,12.5,0,0,1-2.46,1.89,12.64,12.64,0,0,1-2.61,1.68,7.5,7.5,0,0,1,2.31-2.1A7.66,7.66,0,0,1,270.77,237.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.94,231.43c-.1.1-1-.55-2-1.46s-1.7-1.73-1.6-1.83,1,.54,2,1.45S273,231.32,272.94,231.43Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.32,224.15a7.95,7.95,0,0,1,1.84-4.56,8,8,0,0,1-.8,2.33A8.29,8.29,0,0,1,278.32,224.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.72,242.83c-.08.11-1.05-.51-2-1.58a4.51,4.51,0,0,1-1.27-2.18c.13-.07.78.82,1.66,1.84S280.82,242.72,280.72,242.83Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.43,233.91c-.1.11-1-.64-2.09-1.67s-1.83-1.94-1.73-2.05a7.09,7.09,0,0,1,2.09,1.68C283.75,232.89,284.53,233.81,284.43,233.91Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.06,240.73a12.83,12.83,0,0,1-2.23,1.88,14.44,14.44,0,0,1-2.31,1.79,6.11,6.11,0,0,1,2-2.19A6.23,6.23,0,0,1,294.06,240.73Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.78,232.91c.09.12-.88,1-2.16,2a8.59,8.59,0,0,1-2.48,1.59,8.53,8.53,0,0,1,2.16-2A8.88,8.88,0,0,1,293.78,232.91Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.57,226.47a5.76,5.76,0,0,1-.62-2.64,5.57,5.57,0,0,1,.2-2.7,9.94,9.94,0,0,1,.32,2.66A9.78,9.78,0,0,1,295.57,226.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289,224.28c.13.07-.17.86-.66,1.77s-1,1.59-1.12,1.52.17-.86.66-1.77S288.86,224.21,289,224.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.42,214.25a16.9,16.9,0,0,1-4.92-3.31,8.68,8.68,0,0,1,2.6,1.44A8.85,8.85,0,0,1,289.42,214.25Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296,210.59a5.6,5.6,0,0,1-2.78-.92,5.7,5.7,0,0,1-2.28-1.84,16.41,16.41,0,0,1,2.53,1.38A16.53,16.53,0,0,1,296,210.59Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.18,214.56a10.67,10.67,0,0,1-2.18.91,10,10,0,0,1-2.21.85c-.08-.11.76-.84,2-1.34A3.92,3.92,0,0,1,301.18,214.56Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.59,225.1a7.94,7.94,0,0,1,.83-3.25,8.26,8.26,0,0,1,1.67-2.91,16.62,16.62,0,0,1-1.18,3.11A17.29,17.29,0,0,1,304.59,225.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.64,229.35a7.39,7.39,0,0,1-.57-2.72,7.6,7.6,0,0,1-.05-2.77,7.3,7.3,0,0,1,.57,2.71A7.68,7.68,0,0,1,311.64,229.35Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.93,220.41a5.66,5.66,0,0,1-.26,2.36,5.47,5.47,0,0,1-.77,2.24,5.61,5.61,0,0,1,.26-2.35A5.55,5.55,0,0,1,241.93,220.41Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.41,235.35a7.92,7.92,0,0,1-4.86-1.46,9.14,9.14,0,0,1,2.46.63A9.27,9.27,0,0,1,252.41,235.35Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.42,207.2c.05.14-.74.53-1.67,1.08s-1.67,1-1.77.93.52-.81,1.5-1.38S264.38,207.07,264.42,207.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.91,217.18a4.82,4.82,0,0,1-2.18-.24c-1.17-.27-2.1-.6-2.06-.74a4.82,4.82,0,0,1,2.18.24C251,216.71,252,217,251.91,217.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.73,205.14c-.05.13-.82-.08-1.56-.68s-1.1-1.32-1-1.39.63.43,1.32,1S270.79,205,270.73,205.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.77,202.36c.1.1-.28.65-.85,1.22s-1.12.94-1.22.84.28-.64.85-1.21S282.67,202.26,282.77,202.36Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M218.86,413.15l-6.32,3.66s4.65,15.19,1.8,12.49c-2.55-2.41-12.08-20.67-14.33-25.18l-.5-1,10.76-5.85Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.92,408.78a6.35,6.35,0,0,0,2.22-3.95,6.15,6.15,0,0,0-1-4.36L199.75,403Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.58,424.37s1.33,5.49.22,5.34-11.43-18.23-15.29-26.6l.37-.18,11.86,21.2S214,423.47,214.58,424.37Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.75,402.68a1.61,1.61,0,0,0,.13.28l.39.81,1.52,3c1.3,2.49,3.14,5.89,5.26,9.6s4.1,7,5.58,9.43l1.76,2.81.49.75.18.26a1.13,1.13,0,0,0-.14-.28l-.46-.78-1.7-2.85c-1.44-2.4-3.4-5.73-5.52-9.44s-4-7.11-5.31-9.57l-1.58-2.92c-.16-.29-.3-.55-.44-.79S199.76,402.67,199.75,402.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.49,424.26a8,8,0,0,1,1.68-.24,7.38,7.38,0,0,1,1.66.35,2.4,2.4,0,0,0-1.65-.57A2.47,2.47,0,0,0,211.49,424.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.19,418.24a3.75,3.75,0,0,0,1.8.08,1.93,1.93,0,0,0-.89-.15A2,2,0,0,0,211.19,418.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.14,416.57c0,.06.29.21.69.34s.74.2.76.14-.29-.21-.69-.35S211.16,416.51,211.14,416.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.17,414.9a2.17,2.17,0,0,0,.37.89c.25.46.51.81.56.78a2.17,2.17,0,0,0-.37-.89C212.48,415.22,212.23,414.88,212.17,414.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.07,414a1.83,1.83,0,0,0,.26,1.08c.26.56.62.92.67.88a5.8,5.8,0,0,0-.47-1A6.63,6.63,0,0,0,213.07,414Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.88,418a3.58,3.58,0,0,0,.59,1,7.09,7.09,0,0,0,.86.95,3.06,3.06,0,0,0,.61.47.59.59,0,0,0,.46.07.44.44,0,0,0,.31-.38,2.15,2.15,0,0,0-1.86-2,2.07,2.07,0,0,0-.87.06.84.84,0,0,0-.29.13,3.22,3.22,0,0,1,1.14,0,2.11,2.11,0,0,1,1.06.54,1.85,1.85,0,0,1,.61,1.26c0,.23-.26.28-.47.16a4.73,4.73,0,0,1-.57-.43,8,8,0,0,1-.87-.9C213.14,418.36,212.91,418,212.88,418Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,418.28a1.19,1.19,0,0,0,.78-.29,1.8,1.8,0,0,0,.58-.7,1.2,1.2,0,0,0,0-1.14.47.47,0,0,0-.65,0,1.29,1.29,0,0,0-.36.43,3.7,3.7,0,0,0-.34.84,1.59,1.59,0,0,0-.08.81s.07-.3.23-.77a3.81,3.81,0,0,1,.37-.77c.13-.26.46-.58.66-.35a1.07,1.07,0,0,1-.05.92,1.94,1.94,0,0,1-.5.66A3.88,3.88,0,0,1,213,418.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.27,400.53s.3.43.62,1.19a5.86,5.86,0,0,1,.41,3.15,6,6,0,0,1-1.35,2.89c-.54.62-1,.91-1,.94a1.06,1.06,0,0,0,.32-.18,4.32,4.32,0,0,0,.76-.66,5.72,5.72,0,0,0,1.45-2.95,5.65,5.65,0,0,0-.48-3.25,5,5,0,0,0-.52-.86C204.37,400.61,204.28,400.52,204.27,400.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.6,409.89a10.71,10.71,0,0,0,1.09,2.44,9.79,9.79,0,0,0,1.51,2.21c.05,0-.6-1-1.32-2.31S205.66,409.86,205.6,409.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.83,406.78c-.06,0-.17.21-.35.45s-.35.42-.32.47.3-.06.5-.34S203.89,406.79,203.83,406.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.62,404.78c-.06,0-.16.18-.24.44s-.08.48,0,.5.16-.18.24-.44S204.68,404.8,204.62,404.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.33,402.73c-.05,0,.08.25.13.53s0,.52.08.54.2-.24.13-.58S204.37,402.68,204.33,402.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,401.36c-.06,0-.09.14-.07.3s.09.29.15.28.09-.15.07-.31S204,401.35,204,401.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.51,427.22l-.23,7.31s15.36,4.07,11.56,5.06c-3.4.9-23.93-.67-28.94-1.14l-1.13-.11.72-12.22Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.38,438.44a6.3,6.3,0,0,0-2.18-4A6.12,6.12,0,0,0,304,433l-.19,5.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.78,436.79s5.36,1.77,4.65,2.63-21.51.07-30.66-1.08l0-.41,24.26,1.14S328.71,436.79,329.78,436.79Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.53,437.91l.31,0,.9.08,3.3.27c2.8.21,6.66.45,10.93.62s8.15.23,10.95.24h3.31l.91,0a1.09,1.09,0,0,0,.31,0,1.09,1.09,0,0,0-.31,0l-.91,0-3.31-.06c-2.8-.05-6.67-.14-10.94-.3s-8.13-.38-10.93-.55l-3.31-.2-.9,0A1.23,1.23,0,0,0,303.53,437.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.06,439.35a7.73,7.73,0,0,1,.68-1.55,7.53,7.53,0,0,1,1.18-1.23,2.51,2.51,0,0,0-1.37,1.1A2.44,2.44,0,0,0,328.06,439.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.79,436.42s.32-.27.6-.68.47-.77.42-.8-.32.27-.6.68S322.74,436.38,322.79,436.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.34,435.58c0,.05.34-.13.66-.4s.56-.53.52-.58-.34.14-.66.41S321.3,435.54,321.34,435.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.47,433.83a4.4,4.4,0,0,0,1.91.09,2.23,2.23,0,0,0-.95-.16A2.27,2.27,0,0,0,320.47,433.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.2,432.6a1.89,1.89,0,0,0,1.05.35,2,2,0,0,0,1.1-.1,5.19,5.19,0,0,0-1.08-.12A6.34,6.34,0,0,0,320.2,432.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.47,434.85a3.12,3.12,0,0,0,1.17,0,6.69,6.69,0,0,0,1.25-.23,3.21,3.21,0,0,0,.73-.26.64.64,0,0,0,.3-.36.44.44,0,0,0-.16-.47,2.17,2.17,0,0,0-3.09,1.29.78.78,0,0,0,0,.32,3.29,3.29,0,0,1,.57-1,2.06,2.06,0,0,1,1-.61,1.79,1.79,0,0,1,1.39.15c.18.14.1.36-.11.47a3.21,3.21,0,0,1-.67.26,9.18,9.18,0,0,1-1.22.27C323.91,434.83,323.47,434.82,323.47,434.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.77,434.92a1.17,1.17,0,0,0,.16-.81,2,2,0,0,0-.28-.86,1.19,1.19,0,0,0-1-.64.48.48,0,0,0-.38.53,1.33,1.33,0,0,0,.18.53,3.36,3.36,0,0,0,.53.73,1.76,1.76,0,0,0,.65.5s-.23-.22-.53-.6a4.28,4.28,0,0,1-.47-.72c-.15-.26-.24-.71.05-.75s.59.29.76.53a2.08,2.08,0,0,1,.3.77A4.65,4.65,0,0,1,323.77,434.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.09,432.94s.52,0,1.34.1a5.9,5.9,0,0,1,2.9,1.32,6,6,0,0,1,1.73,2.66c.25.8.26,1.32.3,1.32a1.33,1.33,0,0,0,0-.37,4.7,4.7,0,0,0-.16-1,5.62,5.62,0,0,0-1.74-2.79,5.69,5.69,0,0,0-3-1.31,4.91,4.91,0,0,0-1,0C304.22,432.89,304.09,432.92,304.09,432.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.74,436.76a11,11,0,0,0,2.65.36,10,10,0,0,0,2.68-.11c0-.06-1.2,0-2.67-.11S312.75,436.69,312.74,436.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.17,436.61c0,.05.09.26.2.54s.17.52.23.52.11-.29,0-.61S309.21,436.57,309.17,436.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.89,434.89c-.05,0,.06.23.25.43s.36.33.41.28-.07-.23-.25-.43S307.93,434.85,307.89,434.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,434.05c0,.06.26.07.52.17s.45.26.5.22-.09-.3-.42-.43S306,434,306,434.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,433.63c0,.06.07.16.22.22s.29.07.31,0-.07-.16-.22-.22S304.66,433.58,304.64,433.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.77,298.47s-1.32,34.85-6.66,52.92-19.68,22.46-29,28.28c-8.86,5.55-28.67,16.07-28.67,16.07l11.18,19.37s54.67-23.14,64.42-43.85c7.48-15.91,15.67-45.2,15.67-45.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.47,282.88s23.06,48.3,29.22,61.41a9.24,9.24,0,0,1,.87,4.39l-4.07,81.41-23.39-1.18,2.53-78.51L265,300.69a36.39,36.39,0,0,1-7.11-14.42,23.18,23.18,0,0,1-.66-5.27h0l42.27,1.88",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.5 393.2 186.54 408.56 176.32 254.57 384.7 239.98 396.5 393.2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.5,393.2s-.09-.95-.24-2.79-.36-4.57-.65-8.12c-.56-7.12-1.38-17.57-2.43-30.92-2.09-26.68-5.07-65-8.69-111.37l.22.19L176.34,254.83l.24-.28c0,.36,0,.74.08,1.13,3.63,54.82,7.07,106.81,10.12,152.87l-.25-.22,151.5-11,43.08-3.09,11.44-.81,2.94-.2,1-.06s-.32,0-1,.09l-2.92.23-11.38.86-43,3.21L186.56,408.8l-.23,0,0-.24c-3.06-46.06-6.52-98-10.17-152.87,0-.38,0-.77-.08-1.12v-.26l.26,0,208.37-14.54.21,0,0,.21c3.53,46.48,6.45,84.81,8.48,111.53,1,13.33,1.79,23.76,2.32,30.87.26,3.55.47,6.26.6,8.09S396.5,393.2,396.5,393.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.93,263.29c.43,0,2.27,26.45,4.1,59.13s3,59.2,2.54,59.23-2.26-26.45-4.1-59.14S345.5,263.31,345.93,263.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.28,263c.44,0,2.27,26.46,4.11,59.14s3,59.2,2.54,59.22-2.27-26.45-4.1-59.14S326.85,263,327.28,263Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.2,263.8c.43,0,2.27,26.45,4.11,59.13s3,59.21,2.54,59.23-2.27-26.45-4.1-59.14S269.77,263.82,270.2,263.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.24,263c.43,0,2.27,26.46,4.1,59.14s3,59.2,2.54,59.23-2.26-26.45-4.1-59.14S287.81,263.06,288.24,263Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,262.27c.43,0,2.27,26.45,4.1,59.13s3,59.21,2.55,59.23-2.27-26.45-4.11-59.14S305.84,262.29,306.27,262.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15,266.45c.43,0,2.27,26.45,4.1,59.13s3,59.2,2.54,59.23-2.26-26.45-4.1-59.14S249.72,266.47,250.15,266.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.38,267.63c.43,0,2.27,26.45,4.1,59.13S237.46,386,237,386s-2.27-26.45-4.11-59.14S230,267.65,230.38,267.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.61,268.81c.44,0,2.27,26.46,4.11,59.14s3,59.2,2.54,59.23S215,360.73,213.16,328,210.18,268.84,210.61,268.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.5,224.89S213.2,242,217.61,255.66c5.3,16.4,42.56,29.53,42.56,29.53,2.92,2.43,6.12,5,8,6.22,4,2.57,4.14,2.18,4.25,1.61.28-1.51-6.93-4.81-5.17-5.12s8.57,5.2,8.81,3.59c.31-2.1-7.27-5.39-7.9-5.72s-.38-1.37.18-1c.8.48,9.34,5.29,9.66,3.24.18-1.13-1.64-1.64-1.64-1.64s-8.18-3.85-8-4.81,5,1.11,6.63,1.94,2.46.31,2.08-.78c-.26-.74-5.16-3.42-6.76-4.2s-6-2.84-3.4-3.83,4.14-3,4.2-3.92-1.06-1.57-1.64-.87a8.08,8.08,0,0,1-2.35,1.6,5.22,5.22,0,0,1-1.9.56c-3.47-2.13-28.28-17.49-28.38-20.22-.11-2.94,12.5-13.8,12.5-13.8Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.6,175.3c0,.15-.66.12-1.39.23s-1.34.29-1.41.16.49-.56,1.33-.68S279.64,175.17,279.6,175.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.71,174.84c-.1.12-.57-.13-1.19-.23s-1.14-.06-1.19-.2.52-.46,1.29-.32S288.81,174.74,288.71,174.84Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Files--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407,171.83c-7.76,38.51-36,183.3-43.51,221.94a9.79,9.79,0,0,0,7.66,11.46l158.51,32.12a9.79,9.79,0,0,0,11.55-7.73l21.7-111.95,13.53,2.09a6.22,6.22,0,0,0,7.06-5L600,224.35a6.21,6.21,0,0,0-5-7.23l-12.15-2.28,1.59-8.74a9.73,9.73,0,0,0-7.73-11.29L418.35,164.2A9.74,9.74,0,0,0,407,171.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.79 175.55 366.45 397.04 529.07 434.31 580.32 214.38 418.79 175.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.88 167.32 362.61 391.83 527.39 418.04 563.67 195.16 399.88 167.32",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.71 179.07 368.76 406.55 535.55 410.53 541.75 184.79 375.71 179.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.72,179.07l166,5.51H542v.21c-1.73,63.42-3.86,141.45-6.16,225.73v.26h-.26l-1.22,0-165.58-4h-.24v-.24c4.26-134.54,7.13-225.38,7.2-227.47C375.65,181.16,373,272,369,406.56l-.23-.24,165.58,3.92,1.22,0-.27.25c2.34-84.28,4.5-162.31,6.25-225.74l.21.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.36,227.73c0,.44-28.7.39-64.08-.09s-64.07-1.22-64.07-1.65,28.7-.39,64.09.09S518.37,227.3,518.36,227.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.56,247.86c0,.43-28.69.39-64.08-.09s-64.07-1.23-64.06-1.66,28.69-.39,64.08.09S519.57,247.43,519.56,247.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.28,309.55c0,.43-28.7.39-64.08-.09s-64.08-1.22-64.07-1.66,28.69-.39,64.09.1S521.28,309.12,521.28,309.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.28,290c0,.43-28.7.39-64.08-.1s-64.08-1.22-64.07-1.65,28.69-.39,64.09.09S521.28,289.61,521.28,290Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.28,270.52c0,.43-28.7.39-64.08-.09s-64.08-1.22-64.07-1.65,28.69-.39,64.09.09S521.28,270.09,521.28,270.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.34,331.33c0,.43-28.7.39-64.08-.09s-64.07-1.22-64.07-1.65,28.7-.39,64.09.09S519.35,330.9,519.34,331.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519,352.74c0,.43-28.7.39-64.08-.09s-64.08-1.23-64.07-1.66,28.69-.39,64.09.09S519,352.31,519,352.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.6,374.14c0,.43-28.7.39-64.09-.09s-64.07-1.22-64.06-1.65,28.69-.39,64.09.09S518.6,373.71,518.6,374.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 539.67,
    cy: 191.74,
    rx: 40.56,
    ry: 40.6,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.71,
    cy: 191.74,
    r: 40.6,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 535.21,
    cy: 191.74,
    rx: 40.56,
    ry: 40.6,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.85,
    y: 167.82,
    width: 4.74,
    height: 47.85,
    rx: 2.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.84,
    y: 167.84,
    width: 4.74,
    height: 47.82,
    rx: 2.09,
    transform: "translate(343.47 726.96) rotate(-90)",
    style: {
      fill: "#fafafa"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.74a41821518e45ac66e999c2d9052644.svg";
export { ForwardRef as ReactComponent };